function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_667_13434)"
}, React.createElement("path", {
  d: "M15.0259 13.8478L18.595 17.4162L17.4159 18.5953L13.8475 15.0262C12.5198 16.0905 10.8684 16.6694 9.16669 16.667C5.02669 16.667 1.66669 13.307 1.66669 9.16699C1.66669 5.02699 5.02669 1.66699 9.16669 1.66699C13.3067 1.66699 16.6667 5.02699 16.6667 9.16699C16.6691 10.8687 16.0902 12.5201 15.0259 13.8478ZM13.3542 13.2295C14.4118 12.1419 15.0024 10.684 15 9.16699C15 5.94366 12.3892 3.33366 9.16669 3.33366C5.94335 3.33366 3.33335 5.94366 3.33335 9.16699C3.33335 12.3895 5.94335 15.0003 9.16669 15.0003C10.6837 15.0027 12.1416 14.4121 13.2292 13.3545L13.3542 13.2295Z",
  fill: "#808080"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_667_13434"
}, React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

var SvgSearchIcon = function SvgSearchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SearchIcon.ea66dcf0.svg";
export { ForwardRef as ReactComponent };